import { render, staticRenderFns } from "./CartItem.vue?vue&type=template&id=56d6947d&scoped=true"
import script from "./CartItem.vue?vue&type=script&lang=js"
export * from "./CartItem.vue?vue&type=script&lang=js"
import style0 from "./CartItem.vue?vue&type=style&index=0&id=56d6947d&prod&lang=scss&scoped=true"
import style1 from "./CartItem.vue?vue&type=style&index=1&id=56d6947d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d6947d",
  null
  
)

export default component.exports